import { useRef } from 'react';
import { useReduxState } from 'hooks';
import { useFormApi } from 'informed';
import { FileUploader } from 'components/common/uploader';
import { Button } from 'components/common';
import { DisplayField } from 'components/common/form';
import { HomePageSettingsBannerPreview } from '.';

interface Props {
  fieldPrefix?: string;
  setUploader: (uploader: any) => void;
}

const HomePageSettingsBanner = ({ fieldPrefix = '', setUploader }: Props) => {
  const formApi = useFormApi();
  const uploader = useRef<any>(undefined);

  const { messages } = useReduxState();

  const bannerImageField = `${fieldPrefix}homePageBannerImage`;
  const bannerLayoutField = `${fieldPrefix}homePageBannerImageLayout`;
  const bannerPositionField = `${fieldPrefix}homePageBannerImagePosition`;

  const getUploader = (fileUploader: any) => {
    uploader.current = fileUploader;
    setUploader(fileUploader);
  };

  const handleRemove = () => {
    uploader.current?.reset();
    formApi.setValue(bannerImageField, null);
  };

  const handleThumbnailGenerated = ({ preview }) => {
    formApi.setValue(bannerImageField, preview);
  };

  const bannerImage = formApi.getValue(bannerImageField);
  const bannerLayout = bannerImage
    ? formApi.getValue(bannerLayoutField)
    : undefined;
  const bannerPosition = bannerImage
    ? formApi.getValue(bannerPositionField)
    : undefined;

  return (
    <div className="banner">
      <DisplayField field={bannerImageField} />

      <div
        className="uploader"
        style={{ display: bannerImage ? 'none' : 'block' }}
      >
        <FileUploader
          allowedFileTypes={['image/*']}
          dragDrop={true}
          dragDropActions={false}
          getUploader={getUploader}
          icon="file-image"
          id="home-page-banner-image-uploader"
          infoText={messages.homePageSettingsBannerInfoText}
          keyPrefix="uploads/images/original/"
          onThumbnailGenerated={handleThumbnailGenerated}
          placeholder={messages.homePageSettingsBannerPlaceholder}
          uuidAsFilename={true}
        />
      </div>

      {bannerImage ? (
        <div className="banner-image">
          <HomePageSettingsBannerPreview
            bannerImageValue={bannerImage as string}
            bannerLayoutField={bannerLayoutField}
            bannerLayoutValue={bannerLayout as string}
            bannerPositionField={bannerPositionField}
            bannerPositionValue={bannerPosition as string}
            id="home-page-common-banner"
          />
        </div>
      ) : null}

      <div className="remove">
        <Button
          category="light"
          disabled={!bannerImage}
          icon="trash-alt"
          onClick={handleRemove}
          text={messages.commonRemove}
        />
      </div>

      <style jsx>{`
        .uploader {
          max-width: 540px;
        }
        .remove {
          margin-top: 25px;
        }
      `}</style>
    </div>
  );
};

export default HomePageSettingsBanner;
